
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 50 50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M24.333 6A18.28 18.28 0 006 24.333a18.28 18.28 0 0018.333 18.334 18.28 18.28 0 0018.334-18.334A18.28 18.28 0 0024.333 6zm0 33.333c-8.333 0-15-6.666-15-15 0-8.333 6.667-15 15-15 8.334 0 15 6.667 15 15 0 8.334-6.666 15-15 15zM23 16.167a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm1.5 15.5a1.5 1.5 0 01-1.5-1.5v-8.25a1.5 1.5 0 013 0v8.25a1.5 1.5 0 01-1.5 1.5z","fill":"#000"}})])
          )
        }
      }
    